import { put, takeLatest } from 'redux-saga/effects'
import { notification } from 'antd'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { setEventCookie } from '@utils/helpers/authHelper'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.checkStatusEvent
const { set, reset } = rootActions.companies.onboardingExhibitor
const { onSuccess: onSuccessAuthDynamic } = rootActions.ui.authDynamic

function* editorSagaTask({ payload }) {
    const event = payload.event
    try {
        yield put(onSuccessAuthDynamic({ sub_domain: false }))
        const response = yield axios.get(`/companies/stats/onboarding-status/${event._id}`)
        if (response.success) {
            yield put(reset())
            yield put(
                set({
                    type: 'event',
                    value: event
                })
            )
            setEventCookie(event._id)
            yield put(onSuccess(response.result))
            yield put(payload?.sagaCB?.onSuccess(response))
        } else if (response.error) {
            notification.error({
                message: response.error
            })
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editorItpSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editorSagaTask)
}

export default editorItpSaga
